import { render } from "./Result.vue?vue&type=template&id=30077574&bindings={\"isWin\":\"data\",\"allCommands\":\"data\",\"usedCommands\":\"data\",\"unUsedCommands\":\"data\",\"resultDescription\":\"data\",\"defeatDescriptions\":\"data\",\"judgeUnusedCommands\":\"options\"}"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script